import cn from 'classnames';
import { useEffect, useState } from 'react';

import type { ITooltipProps } from '@webapp/common/components/tooltip';
import { Tooltip } from '@webapp/common/components/tooltip';
import { nop } from '@webapp/common/lib/utils';

import css from './switch.css';

export const Switch: FC<{
    label?: ReactNode;
    labelClassname?: string;
    tooltip?: ReactNode;
    defaultChecked?: boolean;
    checked?: boolean;
    dataTestId?: string;
    value?: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    className?: string;
    tooltipProps?: ITooltipProps;
    children?: ReactNode;
}> = ({
    labelClassname,
    children,
    checked,
    dataTestId,
    value,
    onChange = nop,
    defaultChecked,
    disabled,
    label,
    tooltip,
    tooltipProps,
    className,
}) => {
    const [innerChecked, setInnerChecked] = useState<boolean>(defaultChecked);
    let finalChecked = typeof checked !== 'undefined' ? checked : innerChecked;
    finalChecked = typeof value !== 'undefined' ? value : finalChecked; // TODO FIXME used in Forms only

    const handleChange = (): void => {
        if (disabled) {
            return;
        }
        const next = !finalChecked;
        setInnerChecked(next);
        onChange(next);
    };

    useEffect(() => {
        setInnerChecked(defaultChecked);
    }, [defaultChecked]);

    return (
        <div
            className={cn(css.switch, { [css.disabled]: disabled }, className)}
            data-testid={dataTestId}
            onClick={handleChange}
        >
            <div className={cn(css.control, { [css.checked]: finalChecked })} />
            {(label || tooltip) && (
                <div className={cn(css.label, labelClassname)}>
                    {label && <span className={css.text}>{label}</span>}
                    {children}
                    {tooltip && (
                        <Tooltip preventIconClick={true} withTooltipIcon={true} {...tooltipProps}>
                            {tooltip}
                        </Tooltip>
                    )}
                </div>
            )}
        </div>
    );
};
